"use client";

import { c as _c } from "react/compiler-runtime";
import { getTimeAgoShort, numberWithCommas } from "@/helpers/Helpers";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import { useEmoji } from "@/contexts/EmojiContext";
import type { INotificationDropVoted, INotificationDropReacted } from "@/types/feed.types";
import NotificationHeader from "../subcomponents/NotificationHeader";
import { useWaveNavigation } from "../utils/navigationUtils";
export const getNotificationVoteColor = (vote: number) => {
  if (vote > 0) return "tw-text-green";
  if (vote < 0) return "tw-text-red";
  return "tw-text-iron-500";
};
type NotificationUnion = INotificationDropVoted | INotificationDropReacted;
interface Props {
  readonly notification: NotificationUnion;
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onDropContentClick?: (drop: ExtendedDrop) => void;
}
export default function NotificationDropReacted(t0) {
  const $ = _c(58);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    navigateToWave
  } = useWaveNavigation();
  const {
    findCustomEmoji,
    findNativeEmoji
  } = useEmoji();
  const isVoted = (notification as INotificationDropVoted).additional_context.vote !== undefined;
  const isReacted = (notification as INotificationDropReacted).additional_context.reaction !== undefined;
  let actionElement;
  if (isVoted) {
    const voteValue = (notification as INotificationDropVoted).additional_context.vote;
    let t1;
    if ($[0] !== notification.created_at) {
      t1 = getTimeAgoShort(notification.created_at);
      $[0] = notification.created_at;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const timeAgo = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">rated</span>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== voteValue) {
      t3 = getNotificationVoteColor(voteValue);
      $[3] = voteValue;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const t4 = `${t3} tw-font-medium tw-text-sm`;
    const t5 = voteValue > 0 && "+";
    let t6;
    if ($[5] !== voteValue) {
      t6 = numberWithCommas(voteValue);
      $[5] = voteValue;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
      t7 = <span className={t4}>{t5}{t6}</span>;
      $[7] = t4;
      $[8] = t5;
      $[9] = t6;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] !== timeAgo) {
      t9 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t8}{timeAgo}</span>;
      $[12] = timeAgo;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t7 || $[15] !== t9) {
      t10 = <>{t2}{t7}{t9}</>;
      $[14] = t7;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    actionElement = t10;
  } else {
    if (isReacted) {
      const t1 = notification as INotificationDropReacted;
      let emojiNode;
      if ($[17] !== findCustomEmoji || $[18] !== findNativeEmoji || $[19] !== t1.additional_context.reaction) {
        const rawId = t1.additional_context.reaction.replaceAll(":", "");
        emojiNode = null;
        const custom = findCustomEmoji(rawId);
        if (custom) {
          emojiNode = <img src={custom.skins[0].src} alt={rawId} className="tw-max-w-5 tw-max-h-5 tw-object-contain" />;
        } else {
          const native = findNativeEmoji(rawId);
          if (native) {
            let t2;
            if ($[21] !== native.skins[0].native) {
              t2 = <span className="tw-text-[1.2rem] tw-flex tw-items-center tw-justify-center">{native.skins[0].native}</span>;
              $[21] = native.skins[0].native;
              $[22] = t2;
            } else {
              t2 = $[22];
            }
            emojiNode = t2;
          }
        }
        $[17] = findCustomEmoji;
        $[18] = findNativeEmoji;
        $[19] = t1.additional_context.reaction;
        $[20] = emojiNode;
      } else {
        emojiNode = $[20];
      }
      if (!emojiNode) {
        return null;
      }
      let t2;
      if ($[23] !== notification.created_at) {
        t2 = getTimeAgoShort(notification.created_at);
        $[23] = notification.created_at;
        $[24] = t2;
      } else {
        t2 = $[24];
      }
      const timeAgo_0 = t2;
      let t3;
      if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">reacted</span>;
        $[25] = t3;
      } else {
        t3 = $[25];
      }
      let t4;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
        $[26] = t4;
      } else {
        t4 = $[26];
      }
      let t5;
      if ($[27] !== timeAgo_0) {
        t5 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t4}{timeAgo_0}</span>;
        $[27] = timeAgo_0;
        $[28] = t5;
      } else {
        t5 = $[28];
      }
      let t6;
      if ($[29] !== emojiNode || $[30] !== t5) {
        t6 = <>{t3}{emojiNode}{t5}</>;
        $[29] = emojiNode;
        $[30] = t5;
        $[31] = t6;
      } else {
        t6 = $[31];
      }
      actionElement = t6;
    } else {
      return null;
    }
  }
  const baseWave = notification.related_drops[0].wave as any;
  const baseIsDm = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
  let t1;
  if ($[32] !== baseIsDm || $[33] !== baseWave.id || $[34] !== navigateToWave) {
    t1 = serialNo => {
      navigateToWave(baseWave.id, serialNo, baseIsDm);
    };
    $[32] = baseIsDm;
    $[33] = baseWave.id;
    $[34] = navigateToWave;
    $[35] = t1;
  } else {
    t1 = $[35];
  }
  const onReplyClick = t1;
  let t2;
  if ($[36] !== baseIsDm || $[37] !== navigateToWave) {
    t2 = quote => {
      const quoteWave = quote.wave as any;
      const isDirectMessage = quoteWave?.chat?.scope?.group?.is_direct_message ?? baseIsDm;
      navigateToWave(quote.wave.id, quote.serial_no, isDirectMessage);
    };
    $[36] = baseIsDm;
    $[37] = navigateToWave;
    $[38] = t2;
  } else {
    t2 = $[38];
  }
  const onQuoteClick = t2;
  let t3;
  if ($[39] !== notification.related_identity) {
    t3 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[39] = notification.related_identity;
    $[40] = t3;
  } else {
    t3 = $[40];
  }
  let t4;
  if ($[41] !== actionElement || $[42] !== notification.related_identity || $[43] !== t3) {
    t4 = <NotificationHeader author={notification.related_identity} actions={t3}>{actionElement}</NotificationHeader>;
    $[41] = actionElement;
    $[42] = notification.related_identity;
    $[43] = t3;
    $[44] = t4;
  } else {
    t4 = $[44];
  }
  let t5;
  if ($[45] !== notification.related_drops[0]) {
    t5 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[45] = notification.related_drops[0];
    $[46] = t5;
  } else {
    t5 = $[46];
  }
  let t6;
  if ($[47] !== activeDrop || $[48] !== onDropContentClick || $[49] !== onQuote || $[50] !== onQuoteClick || $[51] !== onReply || $[52] !== onReplyClick || $[53] !== t5) {
    t6 = <Drop drop={t5} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[47] = activeDrop;
    $[48] = onDropContentClick;
    $[49] = onQuote;
    $[50] = onQuoteClick;
    $[51] = onReply;
    $[52] = onReplyClick;
    $[53] = t5;
    $[54] = t6;
  } else {
    t6 = $[54];
  }
  let t7;
  if ($[55] !== t4 || $[56] !== t6) {
    t7 = <div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t4}{t6}</div>;
    $[55] = t4;
    $[56] = t6;
    $[57] = t7;
  } else {
    t7 = $[57];
  }
  return t7;
}